import type { Providers } from 'generated/graphql'
import type { TCustomerioUsedFeature } from 'lib/customerio-tracker/customerio-tracker.types'
import type { TBrandContentType } from 'modules/brands/common/brands.types'

import type { Context, INicheTableRow } from '../common/types'

export interface INicheTab {
  territoryId: string
  uploadDateParam: string
  territoryName: string
  providers: Providers[]
  feature?: TCustomerioUsedFeature
  trackingTab?: string
  hideCreateContext?: boolean
  brandType?: TBrandContentType
  skipContextsQuery?: boolean
}

export interface INicheTabView {
  territoryId: string
  niches: INicheTableRow[]
  viewState: ViewState
  tableTitle: string
  loadingRowsCount: number
  onRetry: () => void
  contexts: Context[]
  isLoadingContext: boolean
  activeContext: Context
  hasReachedLimit: boolean
  isDefaultContext: boolean
  handleActiveContext: (index: string) => void
  handleCreateContext: (contextName: string) => Promise<void>
  isCreateDashboardModalOpen: boolean
  handleDashboardModal: () => void
  nicheForDashModal: { id: string; name: string }[]
  territoryName: string
  generatedNicheDescription?: string
  shouldDisplayContextDescription: boolean
  isHappeningNow: boolean
  handleOpenDashboardModal: () => void
  handleTrackClick: ({ name }: { name: string }) => void
  entityId: string
}

export enum ViewState {
  GENERATING = 'generating',
  COMPLETE = 'complete',
  FETCHING = 'fetching',
  EMPTY = 'empty',
  ERROR = 'error',
}
